import { ImportStatusResponse } from '@epi-models/pages/MassUpload';

export const selectImportStatus = (state): ImportStatusResponse =>
  state.beneficiariesImport.importStatus;

export const selectLeaveConfirmationRequested = (state): boolean =>
  state.beneficiariesImport.leaveConfirmationRequested;
